import {
    Popover,
    Button,
    DatePicker,
    Dialog,
    Row,
    Col,
    Checkbox,
    CheckboxGroup,
    Form,
    FormItem,
    Input,
    InputNumber,
    Table,
    TableColumn,
    Tabs,
    TabPane,
    Breadcrumb,
    BreadcrumbItem,
    Select,
    Option,
    Menu,
    MenuItemGroup,
    MenuItem,
    Submenu,
    Card,
    Radio,
    Container,
    Header,
    Main,
    Pagination,
    Loading,
    Notification,
    MessageBox,
    Message,
    Autocomplete,
    Upload,
    Alert,
    Tooltip
} from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'
import Vue from 'vue'

Vue.use(Popover)
Vue.use(Button)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Menu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Card)
Vue.use(Radio)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Pagination)
Vue.use(Loading)
Vue.use(Autocomplete)
Vue.use(Alert)
Vue.use(Tooltip)

Vue.prototype.$notify = Notification
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
